export const servicesItems = [
  {
    img: "assets/Images/vyrobene-na-slovensku.png",
    title: "Slovenská kvalita",
    desc: "Vyrobené na Slovensku",
  },
  {
    img: "assets/Images/modularny-system.png",
    title: "Modulárny systém",
    desc: "Vyskladateľné na mieru",
  },
  {
    img: "assets/Images/dorucenie-zadarmo.png",
    title: "Doručenie zadarmo",
    desc: "V rámci celej SR",
  },
  {
    img: "assets/Images/matrac-a-ulozny-priestor.png",
    title: "Matrac a úložný priestor",
    desc: "S matracom v cene",
  },
];

export const sofaItems = [
  {
    img: "assets/Images/sofa1.png",
    title: "Wooden sofa",
  },
  {
    img: "assets/Images/sofa2.png",
    title: "Fabric sofa",
  },
  {
    img: "assets/Images/sofa3.png",
    title: "L shaped sofa",
  },
  {
    img: "assets/Images/sofa4.png",
    title: "Chester field sofa",
  },
  {
    img: "assets/Images/sofa5.png",
    title: "3 Seater sofa",
  },
  {
    img: "assets/Images/sofa6.png",
    title: "Sofa cum bed",
  },
  {
    img: "assets/Images/sofa7.png",
    title: "2 seater sofa",
  },
  {
    img: "assets/Images/sofa8.png",
    title: "Office sofa",
  },
];

export const PopularItems = [
  {
    img: "assets/Images/popularSofa.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/popularSofa.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/popularSofa.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/popularSofa.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/popularSofa.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/popularSofa.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/popularSofa.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/popularSofa.png",
    title: "Comfy craft",
  },
];

export const RecentlyItemsData = [
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
];
export const productlistItems = [
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
  {
    img: "assets/Images/recently.png",
    title: "Comfy craft",
  },
];

export const ProductImages = [
  {
    img: "assets/Images/product1.png",
  },
  {
    img: "assets/Images/product2.png",
  },
  {
    img: "assets/Images/product3.png",
  },
  {
    img: "assets/Images/product6.png",
  },
  {
    img: "assets/Images/product7.png",
  },
  {
    img: "assets/Images/product8.png",
  },
];

export const cartItems = [
  {
    img: "assets/Images/cart1.png",
    price: "129.00",
  },
  {
    img: "assets/Images/cart2.png",
    price: "129.00",
  },
  {
    img: "assets/Images/cart3.png",
    price: "129.00",
  },
];

export const blogItems = [
  {
    img: "assets/Images/blog1.jpg",
  },
  {
    img: "assets/Images/blog2.jpg",
  },
  {
    img: "assets/Images/blog3.jpg",
  },
  {
    img: "assets/Images/blog4.jpg",
  },
  {
    img: "assets/Images/blog5.jpg",
  },
  {
    img: "assets/Images/blog6.jpg",
  },
  {
    img: "assets/Images/blog1.jpg",
  },
  {
    img: "assets/Images/blog2.jpg",
  },
  {
    img: "assets/Images/blog3.jpg",
  },
  {
    img: "assets/Images/blog4.jpg",
  },
  {
    img: "assets/Images/blog5.jpg",
  },
  {
    img: "assets/Images/blog6.jpg",
  },
  {
    img: "assets/Images/blog1.jpg",
  },
  {
    img: "assets/Images/blog2.jpg",
  },
  {
    img: "assets/Images/blog3.jpg",
  },
  {
    img: "assets/Images/blog4.jpg",
  },
  {
    img: "assets/Images/blog5.jpg",
  },
  {
    img: "assets/Images/blog6.jpg",
  },
  {
    img: "assets/Images/blog1.jpg",
  },
  {
    img: "assets/Images/blog2.jpg",
  },
  {
    img: "assets/Images/blog3.jpg",
  },
  {
    img: "assets/Images/blog4.jpg",
  },
  {
    img: "assets/Images/blog5.jpg",
  },
  {
    img: "assets/Images/blog6.jpg",
  },
  {
    img: "assets/Images/blog1.jpg",
  },
  {
    img: "assets/Images/blog2.jpg",
  },
  {
    img: "assets/Images/blog3.jpg",
  },
  {
    img: "assets/Images/blog4.jpg",
  },
  {
    img: "assets/Images/blog5.jpg",
  },
  {
    img: "assets/Images/blog6.jpg",
  },
];

export const teamItems = [
  {
    img: "assets/Images/team1.jpg",
  },
  {
    img: "assets/Images/team2.jpg",
  },
  {
    img: "assets/Images/team3.jpg",
  },
  {
    img: "assets/Images/team4.jpg",
  },
];

export const offerItems = [
  {
    img: "assets/Images/offer1.jpg",
  },
  {
    img: "assets/Images/offer2.jpg",
  },
  {
    img: "assets/Images/offer3.jpg",
  },
];
